// extracted by mini-css-extract-plugin
export default {"Nav":"style_Nav__+Fj+y"};